<template>
    <div>
        <modal ref="modal" :disable-close="true" :content-class="'md:mt-10 md:mb-10'">
            <div class="bg-purple-900 text-white h-full w-full overflow-y-auto">
                <div class="p-6 font-light md:text-center mb-2">
                    <h1>{{ $t('payment_method') }}</h1>
                </div>

                <div v-if="loading" class="flex justify-center p-10">
                    <div class="loader"></div>
                </div>

                <div class="flex flex-col" v-if="!loading">
                    <div class="flex m-5" v-for="(method, k) in methods" :key="k">
                        <div class="w-2/3 p-2">
                            <h2 class="font-bold uppercase">{{ method.name }}</h2>

                            <div class="text-gray-300 opacity-50">
                                {{ method.description }}

                                <span class="block" style="font-size: 12px" v-if="method.notes">
                                {{ method.notes }}
                                </span>
                            </div>
                        </div>

                        <div class="w-1/3">
                            <button class="btn bg-purple-700 h-full"
                                    @click="select(method.component, method.slug)">
                                {{ $t('select') }}
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    import {Zapin} from "../services/Api";

    export default {
        props: {
            plan: String
        },

        mounted() {
            this.$refs.modal.open();

            this.loadPaymentMethods();
        },

        data() {
            return {
                show: false,
                loading: false,
                methods: []
            }
        },

        methods: {
            loadPaymentMethods() {
                this.loading = true;

                Zapin
                    .plans()
                    .paymentMethods(this.plan)
                    .then(res => {
                        this.methods = res.data;

                        // if(this.methods.length === 1) {
                        //     this.select(this.methods[0].component, this.methods[0].slug);
                        // }
                    })
                    .finally(() => this.loading = false);
            },

            select(component, method) {
                this.$router.push({
                    name: 'Payment',
                    params: {
                        plan: this.plan,
                        component: component,
                        method: method
                    }
                });
            }
        }
    }
</script>